mySmApp.controller("docController", ['$scope', '$http', '$rootScope', '$ocLazyLoad', '$timeout','$location', 'showPageTileService', 'showPage2DataTransformationService',function($scope, $http, $rootScope, $ocLazyLoad, $timeout,$location,showPageTileService,showPage2DataTransformationService) {


    $scope.markerText = intl_msg[27598];
    $scope.perPageText = intl_msg[29044] || "Per Page";
    $scope.documentText = intl_msg[29043] || "Document";
    $scope.documentScope = documentScope;
    $scope.collapsible = true;
    $scope.markerOn = false;
    $scope.markable = documentScope.markable;
    $scope.allowCopy = docViewerParams.allowCopy;
    $scope.documentName = docViewerParams.documentName || documentScope.documentName;
    $scope.cumulativeHighlight = documentScope.cumulativeHighlight;
    $scope.tilesVisible = true;
    $scope.currentZoomLevel = "0";
    $scope.entityIdToClassNameMap = {80:'entity_workOrderRequest',63:'entity_workOrderRequest',16:'entity_interpretation',
    12:'entity_obligation',14:'entity_serviceLevel',13:'entity_obligation',15:'entity_serviceLevel'};
    $scope.tilesCount = {"obligation":0,"serviceLevels":0,"interpretations":0,"changeRequests":0,"workOrderRequests":0,"documentHistory":0};
    $scope.togglePageList=function(val){
        documentScope.viewPageList= val;
        $scope.$broadcast("removeTotalCountFromTable");
        $rootScope.$broadcast("updatePage",window.documentPdfPageNumber || $location.search().pageno,documentScope.viewPageList, null, null, true);
    }
    $scope.tileSelected = false;
    if(docViewerParams.entityId) {
        requestData("GET", "/tblcontractdocuments/count/docviewer/" + (docViewerParams.entityId)).success(function (resp) {
            $scope.tilesCount["entity_obligation"] = resp[12];
            $scope.tilesCount["entity_serviceLevel"] = resp[14];
            $scope.tilesCount["entity_interpretation"] = resp[16];
            $scope.tilesCount["entity_changeRequest"] = resp[63];
            $scope.tilesCount["entity_workOrderRequest"] = resp[80];
            $scope.tilesCount["entity_documentHistory"] = resp[12];
            showPageTileService.tiles = $scope.tilesCount;
            if (!$scope.$$phase) {
                $scope.$digest();
            }
            if( showPage2DataTransformationService.returnObj.rightTabInfo.length && !$scope.tileSelected) {
                showPage2DataTransformationService.returnObj.rightTabInfo.forEach(function (tile) {
                    if (!$scope.tileSelected && tile.styleClass && $scope.tilesCount.hasOwnProperty(tile.styleClass)) {
                        if($scope.tilesCount[tile.styleClass]){
                            $scope.tileSelected = true;
                            $scope.selectTile(tile);
                        }
                    }
                });

                if(!$scope.tileSelected){
                    var obTile = showPage2DataTransformationService.returnObj.rightTabInfo.find(function(t){
                        return t.shortName == "OB";
                    })
                    if(!obTile){
                        obTile = showPage2DataTransformationService.returnObj.rightTabInfo.find(function (t) {
                            return t.shortName == "CR";
                        });
                    }
                    $scope.selectTile(obTile);
                    if(!obTile) {
                        $scope.$root.$broadcast("updatePage", 1,null,null,null,true);
                    }
                }

            }

            showPageTileService.allTilesCount($scope.tilesCount);
        });
    }
    $scope.init = function(){
        var urlParams = $location.search();
        $scope.togglePageList(false);
        if(urlParams.hasOwnProperty('pageno')&& urlParams.pageno != '' && urlParams.hasOwnProperty('parententity') ){
            $("#go").val(urlParams.pageno);
            if(angular.element('.'+$scope.entityIdToClassNameMap[urlParams['parententity']]).length) {
                $timeout(function () {
                    //$scope.viewPageList = true;
                    documentScope.viewPageList = true;
                    angular.element('.' + $scope.entityIdToClassNameMap[urlParams['parententity']]).click();
                }, 0);
            }
        }
    }

    $scope.$on("tileSelect", function($event, data){
        $scope.selectTile(data);
    });

    $scope.getTileCount = function(tab) {
        return $scope.tilesCount[tab.styleClass];
    };

    $scope.zoomIn = function(){
        if(zoom<zoomLimit)
        {
            zoom=zoom+1;
            zoomToLevel((10 + zoom)/10);
        }
        $scope.currentZoomLevel = zoom.toString();
        rescaleBoxes();
    };

    $scope.zoomOut = function(){
        if(zoom>-4)
        {
            zoom=zoom-1;
            zoomToLevel((10 + zoom)/10);
        }
        $scope.currentZoomLevel = zoom.toString();
        rescaleBoxes();
    };

    $scope.changeZoomLevel = function(){
        zoom = Number($scope.currentZoomLevel);
        zoomToLevel(1 + 0.1*$scope.currentZoomLevel);
    };

    $scope.selectTile = function(tab){
        var urlParams = $location.search();
        $scope.selectedTile = tab;
        $scope.selectedTabIndex = 0;
        showPageTileService.setSelectedTile(tab);
        $scope.togglePropValue("selectedTileView",true);
        $scope.togglePropValue("expandDocTree",false);
        $scope.togglePropValue("showDocTree",false);
        if(urlParams.hasOwnProperty('pageno') && urlParams.pageno != '' ){
            $scope.togglePageList(true);
        }
        var DocViewerTabWidth = document.getElementsByClassName("tabs");
        for (var i = 0; i < DocViewerTabWidth.length; i++) {
            DocViewerTabWidth[i].style.width=(100+"%");
        }

    };
    $scope.goToTile = function () {
        $scope.selectedTile = null;
        $scope.togglePropValue("selectedTileView",false);
    };
    $scope.selectTab = function(ind){
        $scope.selectedTabIndex = ind;
        setTimeout(function(){
            $($.fn.dataTable
                .tables( { visible: true, api: true } )).dataTable().fnAdjustColumnSizing(false);
        });
    };
    $scope.renderTable = function(){
        $scope.$root.$broadcast("updatePage",1,null,null,null,true);
    };

    $scope.openFlagDropDown = function () {
        $(".references .docNavOptions").show();
    };
    $scope.removeDoc = function(){
        retainCenterLayout = false;
        $("#docContainer").remove();
        $(".highlightedReference").removeClass("highlightedReference");
        $(window).resize();
        $rootScope.docViewerTab.switchOff = true;
        $rootScope.docViewerTab.active = false;
        setTimeout(function(){
            angular.element("li[tab] a:visible")[0].click();
        });
        rightTabScrollerAdjust();
    };
    $scope.markerClick = function($event){
        $scope.markerOn = !$scope.markerOn;
        if($scope.markerOn){
            $(angular.element($event.currentTarget).closest("#docContainer").find("#0 img")[0]).Jcrop({
                keySupport: false,
                onSelect:   showCoords,
                onChange: removeHighlightedBox
            });
            removeHighlightedBox();
            $scope.markerText = intl_msg[27599];

        } else {
            $scope.markerText = intl_msg[27598];
            if($(angular.element($event.currentTarget).closest("#docContainer").find("#0 img")[0]).data('Jcrop')){
                $(angular.element($event.currentTarget).closest("#docContainer").find("#0 img")[0]).data('Jcrop').destroy();
            }
        }
    };

    $scope.loadDocViewer = function(){
        $scope.currentZoomLevel = "0";
        if($rootScope.docViewerTables){
            if($rootScope.docViewerTab){
                $rootScope.docViewerTab.switchOff = false;
            }
            $rootScope.$broadcast("updateTabsData",$rootScope.docViewerTab);

            $rootScope.docViewerTables.forEach(function(table){
                var tableScope = angular.element("table#table_"+table.id).scope();
                var documentDataUrl = angular.copy(table.fields[0].dataURL);
                var documentDataUrlArray = (documentDataUrl.split("/"));
                documentDataUrlArray[documentDataUrlArray.length-1] = docViewerParams.documentId;
                documentDataUrl = documentDataUrlArray.join("/");
                if(tableScope && tableScope.dataTable){
                    tableScope.$broadcast("refreshData",{dataURL: (appName+documentDataUrl)});
                } else if (tableScope && tableScope.deferredInstance) {
                    tableScope.deferredInstance.resolve("Initiated");
                    tableScope.deferredInstance.promise.then(function () {
                        if (tableScope && tableScope.deferred && tableScope.deferred.promise) {
                            tableScope.deferred.promise.then(function () {
                                tableScope.$broadcast("initializeTable", {dataURL: (appName + documentDataUrl)});

                            })
                        }
                    })
                }
            })
        }
        var loadDocumentViewerOption = function () {
            var apiurl = '/documentviewerstream/references';
            $http.get(apiurl).then(function (response) {
                $scope.loadDocumentOption = response.data;
            })
        }
        $ocLazyLoad.load(getFileNamesWithVersion(["src/scripts/dev/docviewer/docviewer.js","src/scripts/jquery/jquery.Jcrop.min.js","src/styles/jquery.Jcrop.css"])).then(function(){
            loadDocumentView(documentScope);
            loadDocumentViewerOption();
        });



    }

    $scope.init();

}]);